// Others
import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import { IFormSettingGoal, IDetailGoal } from '~/utils/interface/goal';
import { urlApiSettingGoal } from '~/utils/constants/apis';

const settingGoalApi = {
  getDetailGoal: () => {
    const url = urlApiSettingGoal.getDetailGoal;
    return axiosClient.get<IBaseResponse<IDetailGoal>>(url);
  },

  createSettingGoal: (body: IFormSettingGoal) => {
    const url = urlApiSettingGoal.createSettingGoal;
    return axiosClient.post<IBaseResponse>(url, body);
  },
};

export default settingGoalApi;
